import { IonButton, IonContent } from '@ionic/react';
import { ActionFooter } from '@mobile/ui';
import { PhotoGrid } from '@square-photo/components/photo-grid';
import type { PhotoFile } from '@square-photo/types';
import { MAX_PHOTOS } from '@square-photo/stores/photo-converter';

export interface SelectingScreenProps {
  photos: PhotoFile[];
  onAddMore: () => void;
  onRemovePhoto: (id: string) => void;
  onStartConvert: () => void;
}

/** 照片選擇狀態畫面：已選照片網格與「新增／開始轉換」操作。 */
export function SelectingScreen({
  photos,
  onAddMore,
  onRemovePhoto,
  onStartConvert,
}: SelectingScreenProps) {
  const canAddMore = photos.length < MAX_PHOTOS;
  const canConvert = photos.length > 0;

  return (
    <>
      {/* 已選張數在工具列標題上，內容區因此只有網格，捲動時不必讓開任何橫幅 */}
      <IonContent>
        <div className="p-1 md:p-1.5">
          <PhotoGrid
            photos={photos}
            showRemoveButton
            onRemove={onRemovePhoto}
          />
        </div>
      </IonContent>
      <ActionFooter>
        <IonButton
          fill="outline"
          onClick={onAddMore}
          disabled={!canAddMore}
        >
          新增
        </IonButton>
        <IonButton
          onClick={onStartConvert}
          disabled={!canConvert}
          className="flex-1"
        >
          開始轉換
        </IonButton>
      </ActionFooter>
    </>
  );
}
